import React, { FC } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { Image, PageHeader } from '../../UI';
import { TicketsGroupInfo } from './ticketsGroupInfo';
import { PriceInfo } from './priceInfo';
import { CheckoutType } from '../../../store/checkout/types';
import { EventInfoItem } from '../eventInfoItem';
import { useTicketTotalCalculate } from '../../../helpers/customHooks';

export const EventCheckoutHeader: FC<EventCheckoutHeaderProps> = ({
  checkout,
  isAuthorized,
  totalPrice,
  isInitiateLoading = false,
}) => {
  const { event } = checkout.initiate;
  let posterUrl = event.optionPosterUrl;

  if (!posterUrl) {
    posterUrl = event.posterUrl;
  }

  const title = useTicketTotalCalculate(checkout.initiate.ticketGroups, checkout.initiate.event.currency, []);

  return (
    <Header>
      <Poster src={posterUrl} />
      <GradientOverlay />
      <InfoWrapper>
        <List>
          <ListItem>
            <EventInfoItem
              icon="calendar"
              themed
              title={dayjs(event.eventDate).format('DD MMMM YYYY')}
              subtitle={dayjs(event.eventDate).format('LT')}
            />
          </ListItem>
          {event.venue && (
            <ListItem>
              <EventInfoItem
                icon="location"
                themed
                title={event.venue.title}
                subtitle={`${event.venue.address}, ${event.venue.city}`}
              />
            </ListItem>
          )}
          {!checkout.initiate.ticketGroups.length && <TicketsGroupInfo title={title} />}
          <PriceInfo
            checkout={checkout}
            isAuthorized={isAuthorized}
            totalPrice={totalPrice}
            isInitiateLoading={isInitiateLoading}
          />
        </List>
      </InfoWrapper>
    </Header>
  );
};

const InfoWrapper = styled.div`
  z-index: 1;
  width: 100%;
  margin-bottom: 4vh;
`;

const Poster = styled(Image as any)`
  position: absolute;
  object-position: 50% 20%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const GradientOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, transparent 50%);
  pointer-events: none;
  z-index: 1;
`;

const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  padding-left: 50px;
`;

export const ListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const Header = styled(PageHeader as any)`
  max-height: 60vh;
`;

type EventCheckoutHeaderProps = {
  checkout: CheckoutType;
  isAuthorized: boolean;
  totalPrice: number;
  isInitiateLoading?: boolean;
};
